import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, browserLocalPersistence, initializeAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDsb0j2PAGhLb5Lg3NntEuAp3O-4Tz2eFI",
  authDomain: "prednex-ca82c.firebaseapp.com",
  projectId: "prednex-ca82c",
  storageBucket: "prednex-ca82c.firebasestorage.app",
  messagingSenderId: "642062762659",
  appId: "1:642062762659:web:dd9905b4d80c577d1ab516"
};

const app = initializeApp(firebaseConfig);

// Detect platform safely
let platform = 'web';
try {
  if (window.Capacitor && window.Capacitor.getPlatform) {
    platform = window.Capacitor.getPlatform();
  }
} catch (e) {
  // ignore
}

let auth;
if (platform === 'ios') {
  // iOS Capacitor needs browserLocalPersistence (indexedDB hangs)
  auth = initializeAuth(app, {
    persistence: browserLocalPersistence
  });
} else {
  // Android + Web — default getAuth works fine
  auth = getAuth(app);
}

export { auth };
export const googleProvider = new GoogleAuthProvider();
export const isAndroid = () => platform === 'android';
export const isIOS = () => platform === 'ios';
export const isNative = () => platform === 'android' || platform === 'ios';
export default app;
